export default __webpack_public_path__ + "static/media/Health-Support-Header-Banner_2560x600_ret.1aa5f660.jpg";